module.exports = __webpack_public_path__ + "img/strategy_martin.b24b7898.svg";